import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Container } from "@mui/material";

const WelcomeCard = ({ title, subtitle }) => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsHovered(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const cardStyles = {
    transform: isHovered ? "scale(1.05)" : "scale(1)",
    backgroundColor: "#111827",
    boxShadow: 5,
    color: "#ffffff",
    transition: "transform 0.3s",
  };

  return (
    <Container
      maxWidth="md"
      sx={{ mt: 4 }}
    >
      <Card
        elevation={5}
        sx={{ ...cardStyles }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CardContent>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
          >
            {title}
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="textSecondary"
          >
            {subtitle}
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default WelcomeCard;
